import React from "react";
import styles from "./Container.module.less";

export default function Container(props: { className?: string, children: React.ReactNode }) {
    return <div className={[styles.Container, props.className].join(" ")}>{props.children}</div>;
}
